import dayjs from "dayjs";
import { briefInfoType, userState } from "../../../interface/MainInterface";
import { CommonUtils } from "../../../utils/common_utils";

// CSS
import "./CardBrief.css";
import { Box, CardMedia, Typography } from "@mui/material";
import { useEffect } from "react";
import { useWindowSize } from "../../../utils/useWindowSize";

interface propsType {
  index: number;
  selectedKeywords: any;
  taggedKeywords: any;
  briefInfo: briefInfoType;
  checked: boolean;
  callback: any;
  queryText: string;
  userState?: userState;
}

const cUtils = new CommonUtils();

const categoryMapping: { [key: string]: string } = {
  accessory: "패션잡화",
  architecture: "건축",
  beauty: "뷰티",
  culture: "문화",
  design: "디자인",
  "f&b": "F&B",
  fashion: "패션 이슈",
  interior: "인테리어",
  life_style: "라이프 스타일",
  retail: "리테일",
  tech: "테크",
  art: "아트/컬처",
  fashiontrend: "패션 트렌드",
  entertainment: "엔터테인먼트"
};

const CardBrief = (props: propsType) => {
  const windowSize = useWindowSize();

  const mapCategory = (word: string) => {
    return categoryMapping[word] || word; // 매핑된 단어가 없으면 원래 단어 반환
  };

  return (
    <div
      className="brief-box one-third"
      onClick={() => {
        if (props.taggedKeywords) return;
        props.callback({ command: "goBrief", briefInfo: props.briefInfo });
      }}
    >
      {/* <div
        className="brief-cont-wrap"
        onClick={() => {
          props.callback({ command: "goBrief", briefInfo: props.briefInfo });
        }}
      > */}
      <div className="thumb-img">
        {props.briefInfo.image_list[0] ? (
          <img
            loading="lazy"
            src={props.briefInfo.image_list[0]}
            // alt=""
            onError={(e) => {
              console.log("error");
              e.currentTarget.src = "/images/no-image.png";
              e.currentTarget.className = "noImage";
            }}
            style={{ opacity: props.checked ? 0.3 : 1 }}
          />
        ) : (
          <img className="noImage" src="/images/no-image.png" style={{ opacity: props.checked ? 0.3 : 1 }} />
        )}
        <div className="img-category-tag">{mapCategory(props.briefInfo.show_pk)}</div>
        
        {props.taggedKeywords !== null && (
          <div className="tagged-img-wrap">
            <div className="tagged-keyword">
              <span style={{ fontWeight: 700 }}>{`[${props.taggedKeywords}]`}</span>
              <span>{" 키워드로 분류됨"}</span>
            </div>
            <button onClick={(e) => {
              props.callback({
                command: "removeTag",
                key: `${props.briefInfo.show_pk}/${props.briefInfo.sk}`,
                keyword: props.taggedKeywords,
              });
            }}>
              <img style={{ width: "10px", height: "10px", transform: "translate(0)" }} src="/images/icon-arr-re-wht.png" />
              <span style={{ paddingLeft: "4px", fontWeight: 500, fontSize: "14px", color: "#fff" }}>취소</span>
            </button>
          </div>
        )}

      </div>
      <div className="brief-summary">
        <dl>
          <dt>
            <p>{props.briefInfo.ai_title}</p>
            {/* <span style={{ paddingTop: '5px'}}>{props.briefInfo.ai_introduction}</span> */}
          </dt>
          <dd>
            {dayjs(props.briefInfo.sk).format("YYYY-MM-DD HH:mm")}
            {props.userState?.isSuperAdmin && (
              <>
              <Box sx={{ display: "flex", justifyContent: "flex-end" }} onClick={(e) => e.stopPropagation()}>
                <Box className="btn-delete" sx={{ cursor: "pointer", display: "flex" }}>
                  <CardMedia
                    className="btn-delete-img"
                    component={"img"}
                    image="/images/svg-delete.svg"
                    sx={{ height: "18px", width: "18px" }}
                    onClick={() => {
                      props.callback({ command: "deleteBrief", briefInfo: props.briefInfo });
                    }}
                  />
                  {windowSize.width > 1023 && (
                    <Typography
                      className="btn-delete-text"
                      sx={{
                        fontSize: windowSize.width > 1023 ? "16px" : "13px",
                        fontWeight: "500",
                        lineHeight: windowSize.width > 1023 ? "19px" : "16.9px",
                        color: "rgba(138, 138, 138, 1)",
                      }}
                      onClick={() => {
                        props.callback({ command: "deleteBrief", briefInfo: props.briefInfo });
                      }}
                    >
                      {"삭제"}
                    </Typography>
                  )}
                </Box>
              </Box>
              </>
            )}
            {/* <span>
                원본사이트 :{" "}
                <i>
                  <img src={cUtils.genRefSiteLogo(props.briefInfo.ref_site)} alt="" />
                </i>
              </span>
              <span>{dayjs(props.briefInfo.sk).format("YYYY-MM-DD hh:mm:ss")}</span> */}
          </dd>
        </dl>
      </div>
      {/* </div> */}
      {/* {props.selectedKeywords && props.selectedKeywords.length > 0 && props.queryText === "" && ( */}
        <div className="checkbox-wrap" onClick={(e) => e.stopPropagation()}>
          <input
            type="checkbox"
            id={`checkBrief${props.index + 1}`}
            className="check-brief"
            onClick={() => {
              props.callback({
                command: "selectBrief",
                key: `${props.briefInfo.show_pk}/${props.briefInfo.sk}`,
              });
            }}
            onChange={(e) => {}}
            checked={props.checked}
          />
          <label htmlFor={`checkBrief${props.index + 1}`}></label>
        </div>
      {/* )} */}
    </div>
  );
};

export default CardBrief;
